// import Vue from 'vue';
import { createStore } from 'vuex';

import { alert } from './alert.module';
import { authentication } from './authentication.module';
import { users } from './users.module';

// Vue.use(Vuex);


export const store = new createStore({
    modules: {
        alert,
        authentication,
        users
    }
});